/* ============================================================
   Sunnah Grains — theme.js
   Vanilla, no framework. Hooks: scroll-aware header, scroll
   reveal, marquee duplication, mobile drawer, PDP gallery,
   variant swatches, PDP tabs, collection chip filter + sort,
   testimonial rotator.
   ============================================================ */
(function () {
  'use strict';

  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const $ = (sel, root = document) => root.querySelector(sel);

  // ---------- Scroll-aware header ----------
  const header = $('.js-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ---------- Scroll reveal ----------
  {
    const revealEls = $$('.reveal, .stagger');
    const snap = (el) => {
      el.style.transition = 'none';
      el.classList.add('is-visible');
      requestAnimationFrame(() => { el.style.transition = ''; });
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add('is-visible');
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );
      const vh = window.innerHeight || 800;
      revealEls.forEach((el) => {
        // Already on screen at load -> show instantly (no fade-from-black on hero / buy box / first products).
        if (el.getBoundingClientRect().top < vh * 0.95) snap(el);
        else io.observe(el);
      });
    } else {
      revealEls.forEach((el) => el.classList.add('is-visible'));
    }
    // Safety net: nothing ever stays hidden longer than 1s (dead JS, blocked observer, etc.).
    setTimeout(() => { revealEls.forEach((el) => el.classList.add('is-visible')); }, 1000);
  }

  // ---------- Marquee duplicate ----------
  $$('.js-marquee').forEach((track) => {
    const original = track.innerHTML;
    track.innerHTML = original + original + original;
  });

  // ---------- Mobile drawer ----------
  const drawer = $('.js-drawer');
  $$('.js-drawer-open').forEach((b) =>
    b.addEventListener('click', () => drawer && drawer.classList.add('is-open'))
  );
  $$('.js-drawer-close').forEach((b) =>
    b.addEventListener('click', () => drawer && drawer.classList.remove('is-open'))
  );

  // ---------- PDP gallery ----------
  $$('.js-gallery').forEach((gallery) => {
    const main = $$('.js-gallery-main img', gallery);
    const counter = $('.js-gallery-counter', gallery);
    const frame = $('.js-gallery-main', gallery);
    const dots = $$('.js-gallery-dots span', gallery);
    const mobGal = window.matchMedia('(max-width: 1023px)');
    const total = main.length;
    const setActive = (i) => {
      main.forEach((img, idx) => img.classList.toggle('is-active', idx === i));
      $$('.js-gallery-thumb', gallery).forEach((b, idx) =>
        b.classList.toggle('is-active', total ? idx % total === i : idx === i)
      );
      if (counter) counter.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      // On mobile the gallery is a swipe strip — jump it to the chosen image (variant switches use this)
      if (mobGal.matches && frame) frame.scrollTo({ left: i * frame.clientWidth, behavior: 'smooth' });
    };
    $$('.js-gallery-thumb', gallery).forEach((b, i) => b.addEventListener('click', () => setActive(total ? i % total : i)));
    setActive(0);

    // Mobile swipe → keep dots in sync with the visible photo
    if (frame) {
      frame.addEventListener('scroll', () => {
        if (!mobGal.matches) return;
        const i = Math.max(0, Math.min(total - 1, Math.round(frame.scrollLeft / frame.clientWidth)));
        dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      }, { passive: true });
    }

    // Hover-to-zoom lens (matches the prototype) — magnifies the active image toward the cursor
    if (frame && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      frame.classList.add('is-zoomable');
      frame.addEventListener('mousemove', (e) => {
        const img = main.find((m) => m.classList.contains('is-active'));
        if (!img) return;
        const r = frame.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width) * 100;
        const y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(1.6)';
      });
      frame.addEventListener('mouseleave', () => {
        main.forEach((m) => { m.style.transform = ''; });
      });
    }
  });

  // ---------- Variant swatches ----------
  $$('.js-purchase').forEach((root) => {
    const swatches = $$('.js-swatch', root);
    const priceNow = $('.js-price-now', root);
    const priceWas = $('.js-price-was', root);
    const priceSave = $('.js-price-save', root);
    const variantInput = $('.js-variant-id', root);
    const stickyPrice = $('.js-sticky-price') || $('.pdp-sticky__price');
    const stickySize = $('.js-sticky-size');
    const setVariant = (i) => {
      swatches.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
      const s = swatches[i];
      if (!s) return;
      if (variantInput) variantInput.value = s.dataset.variantId;
      if (priceNow) priceNow.textContent = s.dataset.price;
      if (priceWas) priceWas.textContent = s.dataset.compare || '';
      if (priceWas) priceWas.style.display = s.dataset.compare ? '' : 'none';
      if (priceSave) {
        const pct = parseInt(s.dataset.discount, 10);
        if (pct > 0) {
          priceSave.textContent = 'Save ' + pct + '%';
          priceSave.style.display = '';
        } else {
          priceSave.style.display = 'none';
        }
      }
      if (stickyPrice) stickyPrice.textContent = s.dataset.price;
      if (stickySize) {
        stickySize.textContent = s.dataset.vtitle || '';
      }
      const sizeWeight = $('.js-size-weight', root);
      if (sizeWeight) sizeWeight.textContent = s.dataset.weight ? ' · ' + s.dataset.weight : '';
      const mi = s.dataset.mediaIndex;
      if (mi !== undefined && mi !== '') {
        const gt = document.querySelectorAll('.js-gallery-thumb')[parseInt(mi, 10)];
        if (gt) gt.click();
      }
    };
    swatches.forEach((s, i) => s.addEventListener('click', () => setVariant(i)));
  });

  // ---------- Mobile story fold (phones only — desktop shows the full story) ----------
  (() => {
    const fold = $('.js-storyfold');
    if (!fold) return;
    const btn = $('.js-storyfold-btn');
    const mq = window.matchMedia('(max-width: 1023px)');
    const apply = () => {
      if (mq.matches && fold.scrollHeight > 400) {
        if (!fold.classList.contains('is-open')) fold.classList.add('is-folded');
        if (btn) btn.hidden = false;
      } else {
        fold.classList.remove('is-folded');
        if (btn) btn.hidden = true;
      }
    };
    if (btn) btn.addEventListener('click', () => {
      const open = fold.classList.toggle('is-open');
      fold.classList.toggle('is-folded', !open);
      btn.textContent = open ? 'Show less' : 'Read the full story';
      if (!open) fold.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    apply();
    mq.addEventListener('change', apply);
  })();

  // ---------- Mobile section accordions (ingredients / nutrition) ----------
  $$('.js-msec').forEach((sec) => {
    const head = $('.js-msec-head', sec);
    if (!head) return;
    head.setAttribute('aria-expanded', 'false');
    head.addEventListener('click', () => {
      const open = sec.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // ---------- Qty ----------
  $$('.js-qty').forEach((root) => {
    const input = $('input', root);
    $('.js-qty-down', root)?.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    $('.js-qty-up', root)?.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  // ---------- Tabs ----------
  $$('.js-tabs').forEach((root) => {
    const tabs = $$('.tab', root);
    const panels = $$('.tab-panel', root);
    const setTab = (i) => {
      tabs.forEach((t, idx) => t.classList.toggle('is-active', idx === i));
      panels.forEach((p, idx) => p.classList.toggle('is-active', idx === i));
    };
    tabs.forEach((t, i) => t.addEventListener('click', () => setTab(i)));
    setTab(0);
  });

  // ---------- Collection filter + sort ----------
  const cgrid = $('.js-cgrid');
  if (cgrid) {
    const cards = $$('.js-cgrid-item', cgrid);
    const chips = $$('.js-chip');
    const sortBtn = $('.js-sort-btn');
    const sortMenu = $('.js-sort-menu');
    const sortLabel = $('.js-sort-label');
    const countEl = $('.js-coll-count');
    const nounEl = $('.js-coll-noun');
    const clearEl = $('.js-coll-clear');

    const apply = ({ filter, sort } = {}) => {
      // filter
      cards.forEach((c) => {
        const ok = !filter || filter === 'all' || (c.dataset.tags || '').split(',').includes(filter);
        c.style.display = ok ? '' : 'none';
      });
      // sort
      const visible = cards.filter((c) => c.style.display !== 'none');
      // live result count + clear affordance
      if (countEl) countEl.textContent = visible.length;
      if (nounEl) nounEl.textContent = visible.length === 1 ? 'product' : 'products';
      if (clearEl) clearEl.style.display = filter && filter !== 'all' ? '' : 'none';
      if (sort) {
        visible.sort((a, b) => {
          if (sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
          if (sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
          if (sort === 'a-z') return a.dataset.title.localeCompare(b.dataset.title);
          return Number(a.dataset.order) - Number(b.dataset.order);
        });
        visible.forEach((c) => cgrid.appendChild(c));
      }
    };

    let state = { filter: 'all', sort: 'featured' };
    chips.forEach((chip) =>
      chip.addEventListener('click', () => {
        chips.forEach((c) => c.classList.remove('is-active'));
        chip.classList.add('is-active');
        state.filter = chip.dataset.filter;
        apply(state);
      })
    );
    clearEl?.addEventListener('click', () => {
      chips.forEach((c) => c.classList.toggle('is-active', c.dataset.filter === 'all'));
      state.filter = 'all';
      apply(state);
    });
    sortBtn?.addEventListener('click', () => sortMenu.classList.toggle('is-open'));
    $$('.js-sort-option', sortMenu).forEach((opt) =>
      opt.addEventListener('click', () => {
        state.sort = opt.dataset.sort;
        if (sortLabel) sortLabel.textContent = opt.textContent.trim();
        sortMenu.classList.remove('is-open');
        apply(state);
      })
    );
  }

  // ---------- Testimonial rotator ----------
  $$('.js-quote-rotator').forEach((root) => {
    const quotes = $$('.js-quote', root);
    const dots = $$('.js-quote-dot', root);
    let i = 0;
    const setQuote = (n) => {
      i = n;
      quotes.forEach((q, idx) => (q.style.display = idx === n ? '' : 'none'));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === n));
    };
    dots.forEach((d, idx) => d.addEventListener('click', () => setQuote(idx)));
    setInterval(() => setQuote((i + 1) % quotes.length), 7000);
    setQuote(0);
  });

  // ---------- Newsletter success state ----------
  $$('.js-newsletter').forEach((form) => {
    form.addEventListener('submit', () => {
      const msg = $('.js-newsletter-msg', form);
      if (msg) {
        msg.style.opacity = '1';
        setTimeout(() => (msg.style.opacity = '0'), 4000);
      }
    });
  });

  // ---------- Header reading progress ----------
  const progress = $('.js-progress');
  if (progress) {
    let ticking = false;
    const update = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      const ratio = max > 0 ? h.scrollTop / max : 0;
      progress.style.transform = 'scaleX(' + ratio.toFixed(4) + ')';
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  // ---------- 3D tilt (pointer-tracked, GPU transforms) ----------
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion) {
    $$('.js-tilt').forEach((el) => {
      const inner = $('.tilt__inner', el) || el;
      const max = Number(el.dataset.tilt || 7);
      el.addEventListener('mousemove', (e) => {
        const r = el.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width;
        const py = (e.clientY - r.top) / r.height;
        inner.style.setProperty('--rx', (0.5 - py) * max * 2 + 'deg');
        inner.style.setProperty('--ry', (px - 0.5) * max * 2 + 'deg');
        inner.style.setProperty('--gx', px * 100 + '%');
        inner.style.setProperty('--gy', py * 100 + '%');
      });
      el.addEventListener('mouseleave', () => {
        inner.style.setProperty('--rx', '0deg');
        inner.style.setProperty('--ry', '0deg');
      });
    });
  }

  // ---------- FAQ accordion ----------
  $$('.js-faq-item').forEach((item) => {
    const q = $('.faq__q', item);
    const a = $('.faq__a', item);
    if (!q || !a) return;
    q.addEventListener('click', () => {
      const open = item.classList.toggle('is-open');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
    });
  });

  // ---------- PDP sticky add-to-bag (mobile) ----------
  const pdpBar = $('.pdp-sticky');
  const pdpAnchor = $('.purchase__add');
  if (pdpBar && pdpAnchor && 'IntersectionObserver' in window) {
    const io2 = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          const show = !e.isIntersecting && e.boundingClientRect.top < 0;
          pdpBar.classList.toggle('is-visible', show);
          document.body.classList.toggle('has-pdp-bar', show);
        });
      },
      { threshold: 0 }
    );
    io2.observe(pdpAnchor);
  }

  // ---------- Scroll-linked parallax (the premium depth on scroll) ----------
  if (!reduceMotion) {
    const cl = (v, a, b) => Math.max(a, Math.min(b, v));
    const hero = $('.hero');
    const heroBg = hero && $('.hero__bg', hero);
    const heroInner = hero && $('.hero__inner', hero);
    const showcase = $('.showcase');
    const scStage = showcase && $('.showcase__stage', showcase);
    const scMark = showcase && $('.showcase__mark', showcase);
    const scGlow = showcase && $('.showcase__glow', showcase);
    const story = $('.story-grid');
    const storyImg = story && $('.story__media .frame img', story);
    let pTick = false;

    const updatePar = () => {
      const vh = window.innerHeight;
      // Hero: image drifts down, text rises and fades out as you scroll past
      if (hero && heroBg) {
        const r = hero.getBoundingClientRect();
        const p = cl(-r.top / r.height, 0, 1);
        heroBg.style.transform = 'translateY(' + (p * 16).toFixed(2) + '%)';
        if (heroInner) {
          heroInner.style.transform = 'translateY(' + (p * -10).toFixed(2) + '%)';
          heroInner.style.opacity = (1 - cl(p / 0.75, 0, 1)).toFixed(3);
        }
      }
      // Showcase: product floats up, watermark drifts, glow pulses
      if (showcase && scStage) {
        const r = showcase.getBoundingClientRect();
        const p = cl((vh - r.top) / (vh + r.height), 0, 1);
        scStage.style.transform = 'translateY(' + (7 - p * 14).toFixed(2) + '%)';
        if (scMark) scMark.style.transform = 'translateX(' + (-3 + p * 6).toFixed(2) + '%)';
        if (scGlow) scGlow.style.transform = 'translate(-50%,-50%) scale(' + (0.9 + (1 - Math.abs(p - 0.5) * 2) * 0.15).toFixed(3) + ')';
      }
      // Story: image pans gently within its frame as you scroll past
      if (story && storyImg) {
        const r = story.getBoundingClientRect();
        const p = cl((vh - r.top) / (vh + r.height), 0, 1);
        storyImg.style.transform = 'translateY(' + (6 - p * 12).toFixed(2) + '%)';
      }
      pTick = false;
    };

    if (hero || showcase || story) {
      window.addEventListener('scroll', () => { if (!pTick) { requestAnimationFrame(updatePar); pTick = true; } }, { passive: true });
      window.addEventListener('resize', updatePar, { passive: true });
      updatePar();
    }
  }
})();

/* ---------- Cart drawer (AJAX add-to-bag) ---------- */
(() => {
  const drawer = document.querySelector('.js-cdw');
  const backdrop = document.querySelector('.js-cdw-backdrop');
  if (!drawer || !backdrop) return;

  const bodyEl = drawer.querySelector('.js-cdw-body');
  const itemsEl = drawer.querySelector('.js-cdw-items');
  const upsellEl = drawer.querySelector('.js-cdw-upsell');
  const countEl = drawer.querySelector('.js-cdw-count');
  const subEl = drawer.querySelector('.js-cdw-subtotal');
  const totalEl = drawer.querySelector('.js-cdw-total');
  const addedEl = drawer.querySelector('.js-cdw-added');
  const titleTextEl = drawer.querySelector('.js-cdw-title-text');
  const closeBtns = drawer.querySelectorAll('.js-cdw-close');
  const headerCount = document.querySelector('.cart-count');
  const DELIVERY = 28000; // flat Rs.280, in paisa

  // Clean money: "Rs. 1,649" — whole rupees, no decimals, no currency code
  const money = (cents) => 'Rs. ' + Math.round(cents / 100).toLocaleString('en-US');
  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const thumb = (url) => {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=128';
  };

  let lastAddedKey = null;   // line-item key of the item just added (highlight + upsell target)
  let lastAddedVid = null;   // variant id from the add response, resolved to a key on render

  /* Scroll cue: only when the body actually overflows (3+ items) — fade the bottom edge */
  const markScrollable = () => {
    if (!bodyEl) return;
    bodyEl.classList.toggle('is-scrollable', bodyEl.scrollHeight > bodyEl.clientHeight + 4);
  };

  /* ---- Size Ladder: current size dimmed, larger sizes with their compare-at saving, one tap to upsize.
     Falls back to the second-jar line when the item is already the largest size (or has one size). ---- */
  const PRODUCT_CACHE = {};
  let upsized = false;
  let ladderToken = 0;
  const getProduct = (handle) => {
    if (PRODUCT_CACHE[handle]) return Promise.resolve(PRODUCT_CACHE[handle]);
    return fetch('/products/' + handle + '.js').then((r) => r.json()).then((p) => { PRODUCT_CACHE[handle] = p; return p; });
  };
  const savePct = (v) => (v.compare_at_price && v.compare_at_price > v.price)
    ? Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) : 0;

  const renderSecondJar = (target) => {
    if (!target || target.quantity !== 1) { upsellEl.hidden = true; upsellEl.innerHTML = ''; return; }
    const shortName = esc(target.product_title);
    upsellEl.className = 'cdw__upsell js-cdw-upsell';
    upsellEl.innerHTML =
      '<div class="cdw__upsell-tx"><b>Add a second jar of ' + shortName + '</b>' +
      'Delivery stays Rs. 280 &mdash; the second jar ships free.</div>' +
      '<button class="cdw__upsell-add" type="button" data-key="' + esc(target.key) + '" aria-label="Add a second jar of ' + shortName + '">+ Add</button>';
    upsellEl.hidden = false;
  };

  const renderUpsell = (cart) => {
    if (!upsellEl) return;
    let target = null;
    if (lastAddedKey) target = cart.items.filter((it) => it.key === lastAddedKey)[0] || null;
    if (!target && cart.items.length) target = cart.items[0];
    if (!target) { upsellEl.hidden = true; upsellEl.innerHTML = ''; return; }
    const token = ++ladderToken;
    getProduct(target.handle).then((p) => {
      if (token !== ladderToken) return; // a newer render superseded this one
      const vs = (p.variants || []).filter((v) => v.available !== false);
      const idx = vs.findIndex((v) => String(v.id) === String(target.variant_id));
      const larger = idx > -1 ? vs.slice(idx + 1) : [];
      if (!larger.length) {
        if (upsized && idx > -1) {
          upsellEl.className = 'cdw__lad cdw__lad--done js-cdw-upsell';
          upsellEl.innerHTML = '<div class="cdw__lad-h"><b>Good call.</b> <span>Save ' + savePct(vs[idx]) + '% &middot; one delivery</span></div>';
          upsellEl.hidden = false;
        } else renderSecondJar(target);
        requestAnimationFrame(markScrollable);
        return;
      }
      const shown = vs.slice(idx);
      // Hassan, 20 Oct: no "Save %" on the Small (first) jar, only Medium and Extra Large carry the saving.
      const smallestId = String(((p.variants || [])[0] || {}).id);
      const tileSave = (v) => (String(v.id) === smallestId ? 0 : savePct(v));
      const best = shown.reduce((a, b) => (tileSave(b) > tileSave(a) ? b : a), shown[0]);
      upsellEl.className = 'cdw__lad js-cdw-upsell';
      upsellEl.innerHTML =
        '<div class="cdw__lad-h">' + (upsized ? '<b>Good call.</b> ' : '') + 'Bigger jar, bigger saving <span>&middot; same Rs. 280 delivery</span></div>' +
        '<div class="cdw__tiles">' + shown.map((v, i) => {
          const cur = i === 0, pct = tileSave(v);
          const isBest = v.id === best.id && !cur;
          return '<div class="cdw__tile' + (cur ? ' is-cur' : '') + (isBest ? ' is-best' : '') + '">' +
            (isBest ? '<span class="cdw__tile-star">Best value</span>' : '') +
            '<div class="cdw__tile-sz">' + esc(v.title) + '</div>' +
            (pct ? '<div class="cdw__tile-sv">Save ' + pct + '%</div>' : '<div class="cdw__tile-sv">&nbsp;</div>') +
            '<div class="cdw__tile-pr">' + money(v.price) + '</div>' +
            (cur ? '<span class="cdw__tile-tag">In cart</span>'
                 : '<button type="button" class="cdw__tile-tag cdw__tile-go" data-key="' + esc(target.key) + '" data-vid="' + v.id + '" data-qty="' + target.quantity + '" aria-label="Upsize to ' + esc(v.title) + '">Upsize</button>') +
          '</div>';
        }).join('') + '</div>';
      upsellEl.hidden = false;
      requestAnimationFrame(markScrollable);
    }).catch(() => { renderSecondJar(target); requestAnimationFrame(markScrollable); });
  };

  const upsizeTo = (key, vid, qty) => {
    if (bodyEl) { bodyEl.style.opacity = '.5'; bodyEl.style.pointerEvents = 'none'; }
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(() => fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: qty || 1 }) }))
      .then((r) => r.json())
      .then((line) => { lastAddedVid = line && line.variant_id; lastAddedKey = null; upsized = true;
        if (addedEl) { addedEl.textContent = '\u2713 Upsized'; addedEl.hidden = false; } })
      .then(() => refresh())
      .finally(() => { if (bodyEl) { bodyEl.style.opacity = ''; bodyEl.style.pointerEvents = ''; } });
  };

  const render = (cart) => {
    if (countEl) countEl.textContent = '';
    if (subEl) subEl.textContent = money(cart.total_price);
    if (totalEl) totalEl.textContent = money(cart.item_count ? cart.total_price + DELIVERY : 0);
    if (headerCount) headerCount.textContent = cart.item_count;
    drawer.classList.toggle('is-empty', !cart.items.length);
    // "✓ Added" only while the just-added item is still in the cart
    if (addedEl && !addedEl.hidden && (!cart.items.length || !cart.items.some((it) => it.key === lastAddedKey || String(it.variant_id) === String(lastAddedVid)))) addedEl.hidden = true;
    // resolve the just-added variant to its line key (first render after an add)
    if (lastAddedVid && !lastAddedKey) {
      const hit = cart.items.filter((it) => String(it.variant_id) === String(lastAddedVid))[0];
      if (hit) lastAddedKey = hit.key;
    }
    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="cdw__empty">Your cart is empty.<br><a href="/collections/shop-by-products" class="cdw__empty-cta">Browse the shop &rarr;</a></div>';
      renderUpsell(cart);
      requestAnimationFrame(markScrollable);
      return;
    }
    // just-added item first, then the rest in cart order
    const ordered = cart.items.slice().sort((a, b) =>
      (a.key === lastAddedKey ? -1 : 0) - (b.key === lastAddedKey ? -1 : 0));
    itemsEl.innerHTML = ordered.map((it) => {
      const k = esc(it.key);
      const q = it.quantity;
      const isAdded = it.key === lastAddedKey;
      return '<div class="cdw-it' + (isAdded ? ' cdw-it--added' : '') + '" data-key="' + k + '">' +
        '<img class="cdw-it__img" src="' + esc(thumb(it.image)) + '" alt="" loading="lazy">' +
        '<div class="cdw-it__body">' +
          '<p class="cdw-it__name">' + esc(it.product_title) +
            (it.variant_title && it.variant_title !== 'Default Title' ? ' &mdash; ' + esc(it.variant_title) : '') + '</p>' +
          (isAdded ? '<p class="cdw-it__meta cdw-it__meta--added">Just added</p>' : '') +
          (q > 1 ? '<p class="cdw-it__meta">' + q + ' &times; ' + money(it.final_line_price / q) + '</p>' : '') +
          '<div class="cdw-qty">' +
            '<button class="cdw-qty__btn" type="button" data-key="' + k + '" data-qty="' + q + '" data-dir="-1" aria-label="Decrease quantity">−</button>' +
            '<span class="cdw-qty__n">' + q + '</span>' +
            '<button class="cdw-qty__btn" type="button" data-key="' + k + '" data-qty="' + q + '" data-dir="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cdw-it__right">' +
          '<span class="cdw-it__price">' + money(it.final_line_price) + '</span>' +
          '<button class="cdw-it__rm" type="button" data-key="' + k + '" data-remove="1">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');
    renderUpsell(cart);
    renderWhispers(cart, ordered);
    requestAnimationFrame(markScrollable);
  };

  /* Whisper: on every item that is NOT the ladder's target, a one-line upsize link if a larger size exists */
  let whisperToken = 0;
  const renderWhispers = (cart, ordered) => {
    const token = ++whisperToken;
    const targetKey = lastAddedKey || (cart.items.length ? cart.items[0].key : null);
    ordered.forEach((it) => {
      if (it.key === targetKey) return;
      getProduct(it.handle).then((p) => {
        if (token !== whisperToken) return;
        const vs = (p.variants || []).filter((v) => v.available !== false);
        const idx = vs.findIndex((v) => String(v.id) === String(it.variant_id));
        if (idx < 0 || idx === vs.length - 1) return;
        const larger = vs.slice(idx + 1);
        const best = larger.reduce((a, b) => (savePct(b) > savePct(a) ? b : a), larger[0]);
        const row = itemsEl.querySelector('.cdw-it[data-key="' + it.key.replace(/"/g, '&quot;') + '"] .cdw-it__body');
        if (!row || row.querySelector('.cdw-it__up')) return;
        const pct = savePct(best);
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'cdw-it__up';
        btn.dataset.key = it.key; btn.dataset.vid = best.id; btn.dataset.qty = it.quantity;
        btn.innerHTML = 'Upsize to ' + esc(best.title) + (pct ? ' &middot; save ' + pct + '%' : '');
        row.appendChild(btn);
        requestAnimationFrame(markScrollable);
      }).catch(() => {});
    });
  };

  const refresh = () => fetch('/cart.js').then((r) => r.json()).then(render);

  /* ---- open / close, with Android back-button, scroll lock, focus return ---- */
  let isOpen = false;
  let pushedState = false;
  let returnFocusEl = null;
  let lockedScrollY = 0;

  const lockPage = () => {
    lockedScrollY = window.scrollY || 0;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';
  };
  const unlockPage = () => {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.touchAction = '';
    if (window.scrollY !== lockedScrollY) window.scrollTo(0, lockedScrollY);
  };

  const open = (justAdded) => {
    if (addedEl) addedEl.hidden = !justAdded;
    if (titleTextEl) titleTextEl.hidden = false;
    returnFocusEl = document.activeElement;
    drawer.hidden = false;
    backdrop.hidden = false;
    drawer.style.transform = '';
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      markScrollable();
    });
    lockPage();
    isOpen = true;
    // Android back button closes the sheet instead of leaving the page
    try { history.pushState({ cdw: true }, ''); pushedState = true; } catch (e) { pushedState = false; }
    const c = drawer.querySelector('.js-cdw-close');
    if (c) c.focus({ preventScroll: true });
  };

  const close = (fromHistory) => {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open', 'is-dragging');
    backdrop.classList.remove('is-open');
    drawer.style.transform = '';
    unlockPage();
    if (pushedState && !fromHistory) { pushedState = false; try { history.back(); } catch (e) {} }
    pushedState = false;
    setTimeout(() => { drawer.hidden = true; backdrop.hidden = true; }, 340);
    if (returnFocusEl && returnFocusEl.focus) { try { returnFocusEl.focus({ preventScroll: true }); } catch (e) {} }
  };

  window.addEventListener('popstate', () => { if (isOpen) close(true); });
  closeBtns.forEach((b) => b.addEventListener('click', () => close(false)));
  backdrop.addEventListener('click', () => close(false));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && isOpen) close(false); });

  /* Swipe down on the handle / header to dismiss */
  (() => {
    const zones = [drawer.querySelector('.js-cdw-grab'), drawer.querySelector('.js-cdw-head')].filter(Boolean);
    let startY = 0, dy = 0, dragging = false;
    zones.forEach((z) => {
      z.addEventListener('touchstart', (e) => { startY = e.touches[0].clientY; dy = 0; dragging = true; drawer.classList.add('is-dragging'); }, { passive: true });
      z.addEventListener('touchmove', (e) => {
        if (!dragging) return;
        dy = Math.max(0, e.touches[0].clientY - startY);
        drawer.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });
      z.addEventListener('touchend', () => {
        if (!dragging) return;
        dragging = false;
        drawer.classList.remove('is-dragging');
        if (dy > 80) close(false); else drawer.style.transform = '';
      });
    });
  })();

  // Focus trap — keep Tab within the open sheet (honours aria-modal)
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !isOpen) return;
    const focusables = Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      (el) => el.offsetParent !== null
    );
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (!drawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  const changeQty = (key, quantity) => {
    if (bodyEl) { bodyEl.style.opacity = '.5'; bodyEl.style.pointerEvents = 'none'; }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then((r) => r.json())
      .then(render)
      .finally(() => { if (bodyEl) { bodyEl.style.opacity = ''; bodyEl.style.pointerEvents = ''; } });
  };

  if (bodyEl) {
    bodyEl.addEventListener('click', (e) => {
      const qtyBtn = e.target.closest('.cdw-qty__btn');
      const rm = e.target.closest('.cdw-it__rm');
      const up = e.target.closest('.cdw__upsell-add');
      if (qtyBtn) {
        const next = Math.max(0, parseInt(qtyBtn.dataset.qty, 10) + parseInt(qtyBtn.dataset.dir, 10));
        changeQty(qtyBtn.dataset.key, next);
      } else if (rm) {
        if (rm.dataset.key === lastAddedKey) lastAddedKey = null;
        changeQty(rm.dataset.key, 0);
      } else if (up) {
        up.disabled = true;
        up.textContent = 'Adding…';
        changeQty(up.dataset.key, 2);
      } else if (e.target.closest('.cdw__tile-go, .cdw-it__up')) {
        const t = e.target.closest('.cdw__tile-go, .cdw-it__up');
        t.disabled = true; t.textContent = '…';
        upsizeTo(t.dataset.key, t.dataset.vid, parseInt(t.dataset.qty, 10));
      }
    });
  }

  // Header bag icon → open the cart sheet (no "just added" state, no highlight)
  document.querySelectorAll('a[href*="/cart"].icon-btn, a[aria-label="Cart"]').forEach((bagLink) => {
    bagLink.addEventListener('click', (e) => {
      e.preventDefault();
      lastAddedKey = null; lastAddedVid = null; upsized = false;
      if (addedEl) addedEl.textContent = '✓ Added';
      itemsEl.innerHTML = '<p class="cdw__empty">Loading your cart…</p>';
      if (upsellEl) upsellEl.hidden = true;
      if (subEl) subEl.textContent = '…';
      open(false);
      refresh();
    });
  });

  const form = document.getElementById('pdp-form');
  if (form) {
    let adding = false; // double-tap guard — one submit per request, ever
    form.addEventListener('submit', (e) => {
      const sub = e.submitter;
      if (sub && sub.name === 'return_to') return; // Buy It Now → native redirect to checkout
      e.preventDefault();
      if (adding) return;
      adding = true;
      lastAddedKey = null; lastAddedVid = null; upsized = false;
      if (addedEl) addedEl.textContent = '✓ Added';
      // Open instantly (optimistic UI); contents stream in behind the animation
      itemsEl.innerHTML = '<p class="cdw__empty">Adding to your cart…</p>';
      if (upsellEl) upsellEl.hidden = true;
      if (subEl) subEl.textContent = '…';
      open(true);
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(
          (r) => {
            if (!r.ok) { close(false); form.submit(); return; } // add truly failed → native fallback (once)
            return r.json().then((line) => { lastAddedVid = line && line.variant_id; }).catch(() => {})
              .then(() => refresh()).catch(() => {}).finally(() => { adding = false; });
          },
          () => { close(false); form.submit(); } // network failure → native fallback
        );
    });
  }
})();

/* ============================================================
   SALES COUNTER — split-flap flip animation
   Server renders the total; this builds the tiles and counts up
   when the counter scrolls into view. Plain number stays if JS
   never runs, so the counter can't render as a row of zeros.
   ============================================================ */
(function () {
  const units = Array.prototype.slice.call(document.querySelectorAll('.js-sgcount'));
  if (!units.length) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  units.forEach((el) => {
    const total = parseInt(el.dataset.total, 10);
    const pad = parseInt(el.dataset.pad, 10);
    if (!total || !pad) return;

    const plain = el.querySelector('.sgcount__plain');
    if (plain) plain.remove();

    const tiles = [];
    for (let i = 0; i < pad; i++) {
      const d = document.createElement('div');
      d.className = 'sgcount__d';
      const s = document.createElement('span');
      s.textContent = '0';
      d.appendChild(s);
      el.appendChild(d);
      tiles.push(d);
    }
    el._sgTiles = tiles;
  });

  function run(el) {
    const tiles = el._sgTiles;
    if (!tiles) return;
    const total = parseInt(el.dataset.total, 10);
    const pad = parseInt(el.dataset.pad, 10);
    const final = String(total).padStart(pad, '0');

    if (reduce) {
      tiles.forEach((t, i) => { t.firstChild.textContent = final[i]; });
      return;
    }

    let start = null, prev = '';
    const DUR = 2200;
    function step(now) {
      if (start === null) start = now;
      const p = Math.min(1, (now - start) / DUR);
      const eased = 1 - Math.pow(1 - p, 3);
      const v = String(Math.round(total * eased)).padStart(pad, '0');
      if (v !== prev) {
        for (let i = 0; i < tiles.length; i++) {
          const s = tiles[i].firstChild;
          if (s.textContent !== v[i]) {
            s.textContent = v[i];
            tiles[i].classList.remove('is-flip');
            void tiles[i].offsetWidth; // restart the animation
            tiles[i].classList.add('is-flip');
          }
        }
        prev = v;
      }
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { run(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.4 });
    units.forEach((el) => io.observe(el));
  } else {
    units.forEach(run);
  }
})();

/* ============================================================
   ZOOM LOCK — iOS Safari ignores user-scalable=no, so the pinch
   gesture events have to be cancelled directly. touch-action in
   theme.css handles every other browser.
   ============================================================ */
(function () {
  // Only the pinch gesture is cancelled. Taps are left completely alone —
  // touch-action in theme.css already blocks double-tap zoom, and swallowing
  // touchend here would eat fast legitimate taps (qty +/-, Add to Cart).
  ['gesturestart', 'gesturechange', 'gestureend'].forEach((evt) => {
    document.addEventListener(evt, (e) => { e.preventDefault(); }, { passive: false });
  });
})();
